import styles from './Skeleton.module.css'

export interface SkeletonProps {
  /** Number of text lines, or a block with explicit size. */
  lines?: number
  width?: number | string
  height?: number | string
  variant?: 'text' | 'block' | 'row'
  label?: string
}

export function Skeleton({ lines = 1, width, height, variant = 'text', label = 'Loading' }: SkeletonProps) {
  if (variant === 'block') {
    return <span role="status" className={`${styles.bone} ${styles.block}`} style={{ width, height }}><span className="sr-only">{label}</span></span>
  }
  return (
    <span role="status" className={styles.group}>
      {Array.from({ length: lines }, (_, i) => (
        <span
          key={i}
          aria-hidden="true"
          className={`${styles.bone} ${variant === 'row' ? styles.row : styles.text}`}
          style={{ width: width ?? (variant === 'text' && lines > 1 && i === lines - 1 ? '62%' : '100%'), height }}
        />
      ))}
      <span className="sr-only">{label}</span>
    </span>
  )
}
